import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/saemitalk/saemi_character.png'


const _hoisted_1 = { style: {"background-color":"rgba(0, 0, 0, 0.7)"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 새미톡 소개 ")
const _hoisted_3 = { class: "bubble yellow ma-3 py-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 안녕하세요! ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 저는  ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "뇌건강 지킴이 새미", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("에요! ")
const _hoisted_8 = { class: "bubble white ma-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, " 새미는 '새미톡'을 상징하는 AI 친구입니다. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 신체 운동을 할 때에도 코치가 필요한 것 처럼")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 뇌운동에도 도움을 주는 조력자의 역할은 큰 도움이 됩니다. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 뇌 운동을 꾸준히 할 수 있도록 도와주고 지속적으로 격려해주는 AI친구 '새미'는 인공지능 분석을 통해 여러분의 뇌운동을 꾸준히 할 수 있도록 돕는 귀여운 친구입니다. ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 뇌 운동을 꾸준히 할 수 있도록 도와주고")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 지속적으로 격려해주는 AI친구 '새미'는 인공지능 분석을 통해")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 여러분의 뇌운동을 꾸준히 할 수 있도록 돕는 귀여운 친구입니다. ")

import SaemitalkDetail from "./SaemitalkDetail.vue";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([{
      backgroundImage:
        'url(' + require('../../assets/saemitalk/saemi_background.webp') + ')',
    }, {"background-size":"cover","background-position":"center"}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_container, {
        class: "py-16",
        style: {"max-width":"1200px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "elevation-0 pb-12",
            style: {"background-color":"transparent"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "pa-5",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-lightbulb-on",
                    color: "rgb(255, 204, 2)",
                    size: "40"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_title, {
                class: _normalizeClass(["text-white font-weight-bold justify-center", { 'text-h5': _unref(xs) }]),
                style: {"font-size":"2.25rem"}
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_row, {
                class: "pt-8",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "3",
                    "align-self": "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _imports_0,
                        class: _normalizeClass(["saemiCharacter", { xs: _unref(xs) }])
                      }, null, 8, ["class"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "auto"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_card_subtitle, {
                          class: _normalizeClass(["font-weight-medium", { 'text-h6': _unref(xs) }]),
                          style: {"line-height":"1.5","font-size":"1.75rem","opacity":"1"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_card_subtitle, {
                          class: _normalizeClass(["font-weight-medium", { 'text-h6': _unref(xs) }]),
                          style: {"font-size":"1.75rem","line-height":"1.5","opacity":"1"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _hoisted_6,
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_v_card_text, {
                          class: _normalizeClass(["text-black", { 'text-subtitle-1': _unref(xs) }]),
                          style: {"font-size":"1.25rem","line-height":"1.25","opacity":"1","word-break":"keep-all"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _hoisted_10,
                            _hoisted_11,
                            _hoisted_12,
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_unref(xs))
                          ? (_openBlock(), _createBlock(_component_v_card_text, {
                              key: 0,
                              class: "text-subtitle-1 text-black",
                              style: {"font-size":"1.25rem","line-height":"1.25","opacity":"1","word-break":"keep-all"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_card_text, {
                              key: 1,
                              class: "text-black",
                              style: {"font-size":"1.25rem","line-height":"1.25","opacity":"1","word-break":"keep-all"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15,
                                _hoisted_16,
                                _hoisted_17,
                                _hoisted_18,
                                _hoisted_19
                              ]),
                              _: 1
                            }))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(SaemitalkDetail)
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})